import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgHomeAlt = function SvgHomeAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#home-alt_svg__clip0)"
  }, React.createElement("path", {
    d: "M12.614 11.648a2.016 2.016 0 100-4.03 2.016 2.016 0 000 4.03z"
  }), React.createElement("path", {
    d: "M24.317 10.742l-11-10a.954.954 0 00-.703-.281.954.954 0 00-.703.281l-10.953 10a1.02 1.02 0 000 1.406 1.02 1.02 0 001.406 0l.265-.312v8.703c0 1.64 1.36 3 3 3h3c1.079 0 2.016-.89 2.016-2.016V17.54c0-1.078.89-2.016 2.016-2.016a2 2 0 012.015 2.016v3.984c0 1.079.89 2.016 2.016 2.016h3c1.64 0 3-1.36 3-3v-8.703l.312.312c.188.188.47.282.703.282.235 0 .516-.094.704-.282.28-.375.28-1.03-.094-1.406zm-3.735 9.844a.99.99 0 01-.984.984h-3v-3.984a3.98 3.98 0 00-3.984-3.984 3.981 3.981 0 00-3.985 3.984v3.984h-3a.99.99 0 01-.984-.984V9.867l7.969-7.015 7.968 6.968v10.766z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "home-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.644)"
  }))));
};

export default SvgHomeAlt;